import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { judgeDeviceType } from "@/utils/device";
import { copy, toast } from '@/utils/util';
import { BRAIN_TYPE_ID, BRAIN_TYPE_TEXT } from '../../../../constants/constData';
@Component({
  components: {
  },
})

export default class BrainCard extends Vue {
  @Prop({default: () => []})
  data:any;
  BRAIN_TYPE_ID = BRAIN_TYPE_ID
  BRAIN_TYPE_TEXT = BRAIN_TYPE_TEXT
  previewImg(imgUrl) {
    this.$navigateTo({
      url: `/baohuo-package/pages/picture-preview/picture-preview?imgUrl=${encodeURIComponent(imgUrl)}`,
    })
  }
  /**
   * 复制文本
   * @param text
   */
  coptyText(text) {
    copy(text).then(() => {
      toast('复制成功');
    })
  }
  deleteBrain(data) {
    this.$emit('delete-brain', data)
  }
}